import { distanceEquals, Point2D, point2DDistanceTo } from '@paragon/geometry-library';
import { Segment2D } from '@paragon/three-shared';

export function segmentLength(segment: Segment2D) {
  return point2DDistanceTo(segment.start, segment.end);
}

export const getTriangleData = (
  segment: Segment2D,
): { hypotenuse: Segment2D; horizontalLeg?: Segment2D; verticalLeg?: Segment2D } => {
  const { start, end } = segment;

  const [hypotenuseStart, hypotenuseEnd] = start.x > end.x ? [end, start] : [start, end];
  const hypotenuse = { start: hypotenuseStart, end: hypotenuseEnd };

  if (distanceEquals(segment.start.x, segment.end.x) || distanceEquals(segment.start.y, segment.end.y)) {
    return {
      hypotenuse,
    };
  }

  const [bottom, top] = start.y > end.y ? [end, start] : [start, end];
  const rightAngleVertex = new Point2D(top.x, bottom.y);

  const horizontalLeg = { start: bottom, end: rightAngleVertex };
  const verticalLeg = { start: top, end: rightAngleVertex };

  return {
    hypotenuse,
    horizontalLeg,
    verticalLeg,
  };
};
